import { createFileRoute, Link } from "@tanstack/react-router";
import { ContentPage } from "../components/content/ContentPage";
import { RevealImage } from "../components/landing/RevealImage";
import { brandify } from "../components/brand";
import { articles, formatArticleDate } from "../content/noutati";

export const Route = createFileRoute("/noutati/")({
  head: () => ({
    meta: [
      { title: "Noutăți — suuper" },
      {
        name: "description",
        content:
          "Ce construim la suuper, cum funcționează prețurile de membru și ce chiar reduce cheltuiala lunară.",
      },
      { name: "robots", content: "index, follow" },
    ],
  }),
  component: NoutatiIndexPage,
});

function NoutatiIndexPage() {
  return (
    <ContentPage
      title="Noutăți"
      intro="Ce construim, cum funcționează și ce am învățat pe drum. Fără comunicate de presă."
    >
      <ul className="space-y-5">
        {articles.map((article) => (
          <li key={article.slug}>
            <Link
              to="/noutati/$slug"
              params={{ slug: article.slug }}
              viewTransition
              className="group block overflow-hidden rounded-[28px] border border-border bg-white shadow-sm transition-shadow hover:shadow-xl"
            >
              <RevealImage
                name={article.image}
                ratio="16/9"
                sizes="(max-width: 768px) 100vw, 720px"
                parallax={false}
                viewTransitionName={`article-${article.slug}`}
                className="w-full"
                imgClassName="transition-transform duration-700 group-hover:scale-105"
              />

              <div className="p-6 sm:p-7">
                <p className="text-sm text-text-muted">
                  {formatArticleDate(article.publishedAt)} ·{" "}
                  {article.readMinutes} min
                </p>
                <h2 className="mt-2 text-2xl font-bold tracking-tight text-text">
                  {brandify(article.title)}
                </h2>
                <p className="mt-3 leading-relaxed text-text-light">
                  {brandify(article.description)}
                </p>
                <p className="mt-4 font-semibold text-primary">Citește →</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </ContentPage>
  );
}
